var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M10 0C4.48545 0 0 4.48545 0 10C0 15.5145 4.48545 20 10 20C15.5145 20 20 15.5145 20 10C20 4.48545 15.5145 0 10 0ZM10.9091 15.4545C10.9091 15.9564 10.5018 16.3636 10 16.3636C9.49818 16.3636 9.09091 15.9564 9.09091 15.4545V8.18182C9.09091 7.68 9.49818 7.27273 10 7.27273C10.5018 7.27273 10.9091 7.68 10.9091 8.18182V15.4545ZM10 5.45455C9.49818 5.45455 9.09091 5.04727 9.09091 4.54545C9.09091 4.04545 9.49818 3.63636 10 3.63636C10.5 3.63636 10.9091 4.04545 10.9091 4.54545C10.9091 5.04727 10.5 5.45455 10 5.45455Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.cd112aef89a391bd5808a79445671e44.svg";
export { ForwardRef as ReactComponent };